import React from 'react';
import { Form } from 'react-bootstrap';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { AiOutlineSearch } from 'react-icons/ai';
import { InputContainer } from './styles';

interface InputSpedProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  onClickIcon?: () => void;
  disabledIcon?: boolean;
  showIcon?: boolean;
  control: Control<FieldValues>;
  isError: boolean;
}

export const InputSped: React.FC<InputSpedProps> = ({
  label = 'Tabela SPED',
  control,
  isError,
  onClickIcon,
  disabledIcon = false,
  showIcon = true,
  ...rest
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if ([69, 109, 107, 194, 110].includes(event.keyCode)) {
      event.preventDefault();
    }
  };

  return (
    <InputContainer>
      <Form.Group>
        <Form.Label>{label}</Form.Label>

        <div className="input-wrapper">
          <Controller
            name="cod_sped"
            control={control}
            render={({ field }) => (
              <input
                {...field}
                {...rest}
                type="text"
                disabled
                className={isError ? 'form-control is-invalid' : 'form-control'}
                style={{ maxWidth: '80px' }}
                onKeyDown={handleKeyDown}
                value={field.value || ''}
              />
            )}
          />

          <Controller
            name="des_sped"
            control={control}
            render={({ field }) => (
              <input
                {...field}
                {...rest}
                type="text"
                disabled
                className={isError ? 'form-control is-invalid' : 'form-control'}
                style={{ marginLeft: '2px' }}
                onKeyDown={handleKeyDown}
                value={field.value || ''}
              />
            )}
          />

          {showIcon && (
            <button
              type="button"
              className="button-input"
              onClick={onClickIcon}
              disabled={disabledIcon}
            >
              <AiOutlineSearch color="#fff" />
            </button>
          )}
        </div>
      </Form.Group>
    </InputContainer>
  );
};
